module.exports = __webpack_public_path__ + "img/locations.6744b568.svg";